import { useSettings } from '@wix/tpa-settings/react';
import { FormType } from '../../../types/types';
import loginSettingsParams from '../../Login/settingsParams';
import signupSettingsParams from '../../Signup/settingsParams';
import { FormSectionSettings } from './FormSection.types';

const PARAMS: Record<FormType, FormSectionSettings> = {
  login: loginSettingsParams,
  signup: signupSettingsParams,
};

interface UseFormSectionSettingsParams {
  formType: FormType;
}

export const useFormSectionSettings = ({
  formType,
}: UseFormSectionSettingsParams) => {
  const settings = useSettings();

  if (!(formType in PARAMS)) {
    return {};
  }
  const settingsParams = PARAMS[formType];

  const showRecaptcha = settings.get(settingsParams.showRecaptcha);
  const submitButtonText = settings.get(settingsParams.submitButtonText);

  return {
    showRecaptcha,
    submitButtonText,
  };
};
